import React from 'react'
import Footer from '../../Footer/Footer'
import GuestHouseHero from './GuestHouseHero'
import GuestHouseContent from './GuestHouseContent'
import GuestHouseServices from './GuestHouseServices'
import GuestHouseTrustSection from './GuestHousesection'
import GuestHouseTransform from './GuestHouseTransform'










function GuestHouseCorporate() {
    return (
        <div>
            <GuestHouseHero/>
            <GuestHouseContent/>
            <GuestHouseServices/>
            <GuestHouseTrustSection/>
            <GuestHouseTransform/>
            <Footer/>
            
        </div>
    )
}

export default GuestHouseCorporate
